import React from 'react'

function Loader() {
    return (
        <div className="preloader flex-column justify-content-center align-items-center">
            <img className="animation__shake" src="dist/img/loading_screen_logo.png" alt="loading_screen_logo.png" height={150} width={150} />
        </div>
    )
}

export default Loader